module.exports = __webpack_public_path__ + "img/smart-climate-sensor-lg.a6c063fc.svg";